import dayjs from 'dayjs'

export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function formatLastActivity(date: string | number): string {
  return capitalizeFirstLetter(dayjs(date).fromNow())
}
